<jhi-spinner *ngIf="circleLoading"></jhi-spinner>


<div class="col-xl">
  <div class="card-wrapper">
    <div class="card card-bg">
      <div class="card-body">
        <div class="container">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span>
            </li>
            <li class="breadcrumb-item" *ngIf="checkListaPrenotazioni()"><a href="javascript:void(0)"
                                                                            (click)="goToListaPrenotazioni()">Lista
              prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToInserimentoDatiPrenotazione()">Dati
              prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToSceltaServiziPrenotazione()">Servizio
              prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Data / ora prenotazione</a></li>
          </ol>
        </nav>
        </div>
        <div style="justify-content: center">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div class="col-xl-10 col-lg-12">
                <div class="card no-after mb-0 pb-0">
                  <div id="custom-card-body" class="card-body mt-0 mb-0 pt-0 pb-0">
                    <div style="justify-content: center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-2">
                        <div class="d-flex" style="justify-content: center">
                          <div style="width: 100px">
                            <div class="text-center label lbl-inserimento-dati" jhiTranslate="progressBar.iTuoiDati">I
                              tuoi dati
                            </div>
                            <button class="btn-last-step btn rounded-circle btn-primary p-1 primary-button" disabled>1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.servizio">
                              Servizio
                            </div>
                            <button class="btn-last-step btn rounded-circle btn-primary p-1 primary-button" disabled>2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.dataOra">Data
                              e ora
                            </div>
                            <button class="btn-actual-step btn rounded-circle btn-primary p-1 border-circle" disabled>
                              3
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati"/>
                          <div style="width: 100px">
                            <div class="lbl-inserimento-dati text-center label" jhiTranslate="progressBar.riepilogo">
                              Riepilogo
                            </div>
                            <button class="btn-next-step btn rounded-circle btn-primary p-1" disabled>4</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <pre>{{appuntamento | json}}</pre> -->
            <div [formGroup]="formSceltaOrario" class="row justify-content-center">
              <div class="col-xxl-9 col-xl-7 col-lg-12">
                <div
                  class="card no-after text-center card-body d-flex flex-xl-row flex-column align-content-center flex-wrap justify-content-between m-4 my-1 p-0">
                  <div class="col-auto col-xxl-3 row-cols-auto mb-2">
                    <h5 class="text-color fw-bold col" jhiTranslate="form.servizio">Servizio</h5>
                    <h6 class="col">{{ this.appuntamento?.servizio?.nmServizio }}</h6>
                  </div>
                  <div class="col-auto row-cols-auto mb-2">
                    <h5 class="text-color fw-bold" jhiTranslate="form.sede">Sede</h5>
                    <h6 class="col">{{ this.appuntamento?.ufficio?.sede?.dlIndirizzo }}</h6>
                  </div>
                  <div class="col-auto col-xxl-2 row-cols-auto mb-2">
                    <span class="text-color h5 fw-bold" jhiTranslate="form.operatore">Operatore</span>
                    <h6 *ngIf="datiDipendente?.id"
                        style="margin-right: 5px;">{{ datiDipendente.nmNome + " " + datiDipendente.nmCognome }}</h6>
                    <h6 *ngIf="!datiDipendente?.id" style="margin-right: 5px;" jhiTranslate="form.Qualsiasi">
                      Qualsiasi</h6>
                  </div>
                </div>
              </div>
            </div>
            <div [formGroup]="formSceltaOrario" class="row justify-content-center">
              <div class="col-xl-4 ps-xxl-4"
                   joyrideStep="primoStep" [stepContent]="primoStep"
                   [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                <div class="card no-after align-items-center">
                  <div class="card-body">
                    <div class="calendar border disable-text-selection position-relative">
                      <div class="month background-primary-normal white-color">
                        <a [ngClass]="disablePrecedent ? 'icon-400' : 'icon-white'" class="nav nav-left">
                          <button class="p-0" (click)="precedentMonth()" [disabled]="disablePrecedent"
                                  [ngClass]="disablePrecedent ? 'background-primary-normal-circle' : 'background-primary-normal-circle-hover'"
                                  style="width: 35px;height: 35px;border-style: none">
                            <svg class="icon">
                              <use href="./content/svg/sprites.svg#it-chevron-left"></use>
                            </svg>
                          </button>
                        </a>
                        <div>
                          <span jhiTranslate="month.{{todayMonth}}">{{ todayMonth }}</span>
                          <span class="year">{{ todayYear }}</span>
                        </div>
                        <a [ngClass]="disableNext ? 'icon-400' : 'icon-white'" class="nav nav-right">
                          <button class="p-0" (click)="nextMonth()" [disabled]="disableNext"
                                  [ngClass]="disableNext ? 'background-primary-normal-circle' : 'background-primary-normal-circle-hover'"
                                  style="width: 35px;height: 35px;border-style: none">
                            <svg class="icon">
                              <use href="./content/svg/sprites.svg#it-chevron-right"></use>
                            </svg>
                          </button>
                        </a>
                      </div>
                      <div class="days">
                        <span jhiTranslate="days.lun">Lun</span>
                        <span jhiTranslate="days.mar">Mar</span>
                        <span jhiTranslate="days.mer">Mer</span>
                        <span jhiTranslate="days.gio">Gio</span>
                        <span jhiTranslate="days.ven">Ven</span>
                        <span jhiTranslate="days.sab">Sab</span>
                        <span jhiTranslate="days.dom">Dom</span>
                      </div>
                      <div class="dates">
                        <div *ngFor="let item of fillPrecEmptyDays(weekdayName); let j=index">
                          <button [ngClass]="{'no-click' : true}">
                            {{ daysInPrecMonth - (lengthPrecMonthDays(weekdayName) - j - 1) }}
                          </button>
                        </div>

                        <div *ngFor="let item of monthDays(daysInMonth); let giorno=index">
                          <button (click)="onClickDay(giorno+1)" [ngClass]="{
                                        'background-secondary-circle' :
                                                     giorno+1 === selectedDay
                                                     && todayMonthDay == selectedMonth
                                                     && todayYear == selectedYear,

                                        'no-click' :
                                                     isHoliday(todayYear, todayMonthDay, giorno+1) ||
                                                     ((todayMonthDay===actualMonthDay && todayYear===actualYear) && giorno+1<actualDayIndex) ||
                                                     (todayYear<=actualYear && todayMonthDay<actualMonthDay) || todayYear<actualYear,
                                        'today-color':
                                                     giorno+1 == actualDayIndex
                                                     && actualMonth == todayMonth
                                                     && actualYear == todayYear}">

                            <time [ngClass]="{'no-click': isHoliday(todayYear, todayMonthDay, giorno+1)}">
                              {{ giorno + 1 }}
                            </time>

                          </button>
                        </div>
                        <div *ngFor="let item of fillNextEmptyDays(42, weekdayName); let j=index">
                          <button [ngClass]="{'no-click' : true}">
                            <time>
                              {{ j + 1 }}
                            </time>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="calendarLoading"
                           style="background-color: #00000055;width: 100%;z-index: 999;position: absolute;height: 100%;"></div>
                    </div>

                    <div *ngIf="calendarLoading" class="progress progress-indeterminate"
                         style="border-radius: 100%;margin-bottom: -0.3em;">
                      <span class="visually-hidden">In elaborazione...</span>
                      <div class="progress-bar background-primary" role="progressbar"></div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-10 col-xl-6 col-lg-8 col-sm-11 pe-xxl-5 mt-4 mt-lg-0 mb-2 d-flex align-items-center"
                   joyrideStep="secondoStep"
                   [stepContent]="secondoStep" [nextTemplate]="nextButton" [prevTemplate]="prevButton">
                <div class="card align-items-center no-after">
                  <div class="card-body">

                    <div *ngIf="skeletonLoading" class="row justify-content-center row-cols-4 placeholder-glow">
                      <div *ngFor="let i of Array(12);" class="col-auto mb-1">
                        <button tabindex="-1" class="btn btn-block primary-button disabled placeholder d-flex">
                          <span *ngIf="selectedLanguage==='it'" style="opacity: 0">00:00</span>
                          <span *ngIf="selectedLanguage==='en'" style="opacity: 0">00:00 AM</span>
                        </button>
                      </div>
                    </div>

                    <div *ngIf="!this.skeletonLoading" class="row justify-content-center row-cols-4">

                      <div *ngIf="(!circleLoading || !skeletonLoading) && (!fasceOrarie || fasceOrarie.length===0)"
                           class="col-auto d-flex">
                        <div class="fw-bold text-center align-middle fs-4" jhiTranslate="form.nessunoSlotDisponibile">
                          Non ci sono slot orari disponibili per il giorno selezionato
                        </div>
                      </div>

                      <div *ngFor="let time of fasceOrarie" class="col-auto"> <!-- col-3 col-xl-4 col-lg-3 -->
                        <button [disabled]="time?.listaIdDipendenti?.length === 0 || time?.listaIdDipendenti == null"
                                [ngClass]="{'focus':time?.orarioInizio === selectedTime}"
                                class="btn btn-block primary-button"
                                (click)="onClickTime(time?.orarioInizio, time?.orarioFine, time?.listaIdDipendenti)">
                          {{
                            convertTimeStringToDate(time!.orarioInizio!.toString()).toLocaleTimeString(this.selectedLanguage!.toString(), {
                              hour: "2-digit",
                              minute: "2-digit"
                            })
                          }}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row" style="justify-content: center">
              <div class="col-xl-12 col-lg-12">
                <div class="card mb-0 pb-0">
                  <div class="card-body mt-4 mb-0 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                      <button (click)="goToSceltaServiziPrenotazione()" class="btn btn-primary primary-button"
                              jhiTranslate="form.indietro">Indietro
                      </button>
                      <button joyrideStep="terzoStep" [stepContent]="terzoStep" [nextTemplate]="nextButton"
                              [prevTemplate]="prevButton"
                              [disabled]="formSceltaOrario.invalid" (click)="goToSceltaRiepilogoPrenotazione()"
                              class="btn btn-primary primary-button"
                              jhiTranslate="form.procedi">Procedi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <button class="btn btn-secondary btn-xs btn-tour" (click)="onTour()">Tour</button>
</div>

<ng-template #nextButton>
  <button class="btn btn-xs" jhiTranslate="tour.button.nextButton">Vai avanti</button>
</ng-template>
<ng-template #prevButton>
  <button class="btn btn-xs" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
</ng-template>
<ng-template #doneButton>
  <button class="btn btn-xs btn-success" jhiTranslate="tour.button.doneButton">Fine</button>
</ng-template>
<ng-template #primoStep>
  <h3 jhiTranslate="tour.scelta-data-ora-prenotazione.primoStep-h3">Seleziona la data desiderata per l'appuntamento</h3>
  <p jhiTranslate="tour.scelta-data-ora-prenotazione.primoStep-p">Clicca sul giorno desiderato per selezionarlo</p>
</ng-template>
<ng-template #secondoStep>
  <h3 jhiTranslate="tour.scelta-data-ora-prenotazione.secondoStep-h3">Seleziona la fascia oraria desiderata</h3>
  <p jhiTranslate="tour.scelta-data-ora-prenotazione.secondoStep-p">Clicca sull'orario desiderato</p>
</ng-template>
<ng-template #terzoStep>
  <h3 jhiTranslate="tour.scelta-data-ora-prenotazione.terzoStep-h3">Premi il bottone prosegui per continuare la
    prenotazione</h3>
  <p></p>
</ng-template>

